export type NavItem = {
  name: string;
  path: string;
};

/**
 * Text-only nav items shared by `SiteHeader` (desktop bar + mobile drawer)
 * and `SiteFooter`, matching the mockup's nav/drawer/`.flinks` link sets.
 */
export const navigation: NavItem[] = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'About', path: '/about-us' },
  { name: 'Testimonials', path: '/testimonials' },
  { name: 'Contact', path: '/contact' },
];
